var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B90A",
    d: "M0 0h18v18H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67 8.061L9 5.776l2.332 2.286 1.355-1.33L9 3.118 5.314 6.732l1.356 1.33zM5.712 9L4.356 7.67 3 9l1.356 1.33L5.712 9zm.958.939L9 12.224l2.332-2.286 1.356 1.329L9 14.883 5.314 11.27l-.002-.002L6.67 9.939zm6.974.391L15 9l-1.356-1.33L12.288 9l1.356 1.33z",
    fill: "#0B0E11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 9L9 7.65l-1.017.997-.117.115-.24.236L7.622 9l.002.002L9 10.35 10.376 9z",
    fill: "#0B0E11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.662ef8dad55b4c273bfc8de7fd2ac8ad.svg";
export { ForwardRef as ReactComponent };